import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'address-particular-price',
	templateUrl: './address-particular-price.component.html',
	styleUrls: ['./address-particular-price.component.scss'],
})
export class AddressParticularPriceComponent implements OnInit {
	@Input() title;
	@Input() price;
	@Input() action;
	@Input() canUpdatePrice;
	@Output() onChange = new EventEmitter();
	priceForm = null;
	isPriceModalOpen = false;
	ngOnInit() {
		this.priceForm = new FormControl(this.price);
	}

	openPriceModal() {
		if (this.canUpdatePrice || this.action === 'create') {
			this.isPriceModalOpen = true;
		}
	}
}
